import { render, staticRenderFns } from "./BnUgyfeltorzs.vue?vue&type=template&id=0cd04481&scoped=true&"
import script from "./BnUgyfeltorzs.vue?vue&type=script&lang=js&"
export * from "./BnUgyfeltorzs.vue?vue&type=script&lang=js&"
import style0 from "./BnUgyfeltorzs.vue?vue&type=style&index=0&id=0cd04481&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd04481",
  null
  
)

export default component.exports